import { API_BASE_URL } from "@/api/api.config";
import useRestQuery from "@/remoteState/useRestQuery";

const useClassroomGetList = (skip = false) => {
  // TODO -- LESS-1153: this hook should have a setter param, so that clients of this hook can pass their state setter in
  // for this hook to set after the fetch
  return useRestQuery(`${API_BASE_URL}/api/v2/classroom/`, skip);
};

export default useClassroomGetList;
